import { render } from "./descriptions.vue?vue&type=template&id=98f06eac&scoped=true&ts=true"
import script from "./descriptions.vue?vue&type=script&lang=ts"
export * from "./descriptions.vue?vue&type=script&lang=ts"

import "./descriptions.vue?vue&type=style&index=0&id=98f06eac&scoped=true&lang=css"

import exportComponent from "/home/runner/work/vue3-admin/vue3-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98f06eac"]])

export default __exports__